import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { DataService } from "@/services/data";
import { LMSDataService } from "@/services/lms_data";
import { ApprenticeshipAppointmentType } from "@/types/apprenticeship/enterprise";
import { UserRoundX } from "lucide-react";
import { DateTime } from "luxon";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function AppointmentAbsentDialog({ appointment, size = 20, children }: { appointment: ApprenticeshipAppointmentType; size?: number; children?: React.ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger
                asChild
                onClick={() => {
                    setIsOpen(true);
                }}
            >
                {children || <UserRoundX width={size} height={size} cursor="pointer" />}
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Marquer le rendez-vous comme absent</DialogTitle>
                    <DialogDescription>En validant, vous marquez le rendez-vous du {DateTime.fromISO(appointment.dt_start).toLocaleString(DateTime.DATETIME_MED)} comme absent.</DialogDescription>
                </DialogHeader>

                <DialogFooter>
                    <Button disabled={loading} variant="outline" onClick={() => setIsOpen(false)}>
                        Annuler
                    </Button>

                    <Button
                        type="submit"
                        disabled={loading}
                        onClick={() => {
                            setLoading(true);
                            const id = appointment.external_id.split(":")[1];
                            // ID is a walter-back booking_eventslot id!
                            LMSDataService.client
                                .url(`/booking/crm/event_slots/${id}/absent/`)
                                .post()
                                .text()
                                .then(() => {
                                    setIsOpen(false);
                                    DataService.client
                                        .url(`/apprenticeship/appointments/${appointment.id}/`)
                                        .patch({ cancelled: true, status: "absent" })
                                        .json()
                                        .then(() => navigate("."));
                                    toast.success("Le rendez-vous a bien été marqué comme absent.");
                                })
                                .catch(() => {
                                    toast.error("Une erreur s'est produite lors de la mise à jour du statut du rendez-vous.");
                                })
                                .finally(() => {
                                    setLoading(false);
                                });
                        }}
                    >
                        {loading ? "Chargement..." : "Valider"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
